import React, { forwardRef, useImperativeHandle, useState } from "react";

import PropTypes from "prop-types";
import ReactDOM from "react-dom";

import { ReactComponent as IconClosePopUp30 } from "../../icons/icon/30/a-icon-closepopup-30.svg";

import "./contentOverlay.scss";

const ContentOverlay = ({
  button,
  children,
  headline,
}, ref) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useImperativeHandle(ref, () => ({
    close: handleClose,
    show: handleShow,
  }));

  return (
    <>
      {React.cloneElement(button, { onClick: handleShow })}
      {
        show && ReactDOM.createPortal(
          <div className="content-overlay">
            <IconClosePopUp30
              className="content-overlay__close"
              onClick={handleClose}
            />
            <div className="content-overlay__content">
              <div className="content-overlay__container-headline">
                {headline}
              </div>
              {children}
            </div>
          </div>,
          document.body,
        )
      }
    </>
  );
};

ContentOverlay.propTypes = {
  button: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  headline: PropTypes.string.isRequired,
};

// eslint-disable-next-line react/display-name
export default forwardRef((props, ref) => ContentOverlay(props, ref));
